import React, { useState, useEffect, useRef } from 'react';

const REVIEWS = [
  {
    name: 'Morten Hansen',
    location: 'Gelsted',
    rating: 5,
    text: 'Børge leverede et fantastisk stykke arbejde med vores nye indkørsel. Fliserne ligger snorlige, og hele processen forløb med god kommunikation og overholdelse af alle aftaler. Kan varmt anbefales!',
    date: 'Juni 2026'
  },
  {
    name: 'Kirsten Nielsen',
    location: 'Middelfart',
    rating: 5,
    text: 'Super professionel hækklipning! Vores hæk har aldrig stået skarpere. De ryddede pænt op efter sig, og prisen var yderst rimelig. Vi vil helt sikkert bruge BP Totalservice igen.',
    date: 'Maj 2026'
  },
  {
    name: 'Jesper Poulsen',
    location: 'Assens',
    rating: 5,
    text: 'Fik etableret ny græsplæne og slået græsset. Meget grundig rådgivning fra start til slut. Man kan mærke, at der er fokus på kvalitet og kundetilfredshed.',
    date: 'April 2026'
  },
  {
    name: 'Hanne Schmidt',
    location: 'Aarup',
    rating: 5,
    text: 'Pålidelig havemand, der altid kommer til tiden og leverer et flot resultat. Rigtig god service og altid et smil på læben. Dejligt med en lokal virksomhed, man kan stole på.',
    date: 'Marts 2026'
  },
  {
    name: 'Thomas Jensen',
    location: 'Gelsted',
    rating: 5,
    text: 'Brolægning i topklasse! Vores nye terrasse er blevet præcis, som vi drømte om. God dialog hele vejen igennem og fantastisk håndværk.',
    date: 'Februar 2026'
  }
];

export default function ReviewsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setCurrentIndex((prevIndex) =>
          prevIndex === REVIEWS.length - 1 ? 0 : prevIndex + 1
        ),
      5000
    );

    return () => {
      resetTimeout();
    };
  }, [currentIndex]);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="relative w-full overflow-hidden py-4">
      {/* Reviews Container */}
      <div className="relative w-full">
        {/* Desktop View (3 Columns) */}
        <div className="hidden lg:grid grid-cols-3 gap-6">
          {[0, 1, 2].map((offset) => {
            const index = (currentIndex + offset) % REVIEWS.length;
            const review = REVIEWS[index];
            return <ReviewCard key={index} review={review} />;
          })}
        </div>

        {/* Tablet View (2 Columns) */}
        <div className="hidden md:max-lg:grid grid-cols-2 gap-6">
          {[0, 1].map((offset) => {
            const index = (currentIndex + offset) % REVIEWS.length;
            const review = REVIEWS[index];
            return <ReviewCard key={index} review={review} />;
          })}
        </div>

        {/* Mobile View (1 Column) */}
        <div className="grid md:hidden grid-cols-1">
          <ReviewCard review={REVIEWS[currentIndex]} />
        </div>
      </div>

      {/* Navigation Dots */}
      <div className="flex justify-center items-center gap-2 mt-8">
        {REVIEWS.map((_, idx) => (
          <button
            key={idx}
            onClick={() => handleDotClick(idx)}
            className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
              currentIndex === idx
                ? 'bg-[--color-brand-green-dark] scale-125'
                : 'bg-[--color-brand-green-light]/40 hover:bg-[--color-brand-green-light]/70'
            }`}
            aria-label={`Gå til anmeldelse ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

function ReviewCard({ review }) {
  return (
    <div className="bg-white rounded-3xl p-8 border border-[--color-brand-sand] shadow-xs flex flex-col justify-between h-full transition-all duration-300">
      <div>
        {/* Stars */}
        <div className="flex items-center gap-1 text-amber-500 mb-4">
          {[...Array(review.rating)].map((_, i) => (
            <i key={i} className="fa-solid fa-star text-sm"></i>
          ))}
        </div>
        {/* Text */}
        <p className="font-sans text-sm text-[--color-brand-muted] leading-relaxed italic mb-6">
          "{review.text}"
        </p>
      </div>
      {/* Author Info */}
      <div className="flex items-center justify-between border-t border-[--color-brand-sand] pt-4 mt-auto">
        <div>
          <h4 className="font-sans font-bold text-sm text-[--color-brand-charcoal]">
            {review.name}
          </h4>
          <p className="font-sans text-xs text-[--color-brand-green-medium] font-medium">
            {review.location}
          </p>
        </div>
        <span className="font-sans text-xs text-[--color-brand-muted]/60">
          {review.date}
        </span>
      </div>
    </div>
  );
}
